import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction } from '@/api/manage';
import film from '@/assets/others/film1.png';
import imgs from '@/assets/others/house.png';
export default {
  mixins: [GetSiteIdMixin],
  data: function data() {
    return {
      params: {
        videoCode: '',
        siteId: '',
        pageNo: '',
        pageSize: '',
        column: '',
        order: ''
      },
      order: 'asc',
      dateArr: [],
      paginationIndex: 1,
      total: 0,
      film: film,
      showPhoto: false,
      siteId: '',
      videoList: [],
      photoList: [],
      // url:window._CONFIG['domianURL'] + "/site/photo/view/"
      url: "https://www.skyray-water.com/iws/site/photo/view/"
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.videoList = [];
      this.showPhoto = false;
      this.siteId = value;
      this.loadVideoList(value);
    },
    showPhoto: function showPhoto(value) {
      if (!value) {
        this.order = 'asc';
        this.params = {
          videoCode: '',
          siteId: '',
          pageNo: '',
          pageSize: '',
          column: '',
          order: ''
        };
      }
    },
    paginationIndex: function paginationIndex(value) {
      console.log('paginationIndex', value);
    }
  },
  methods: {
    onChangeSort: function onChangeSort() {
      this.order = this.order == 'asc' ? 'desc' : 'asc';
      this.toDetail(this.selectedCode);
    },
    onChange: function onChange(pageNo) {
      console.log('pageNo', pageNo);
      this.paginationIndex = pageNo;
      this.toDetail(this.selectedCode);
    },
    // 查询图片时间
    onDateSelectTime: function onDateSelectTime(value, dateArr) {
      this.params.stime = dateArr[0];
      this.params.etime = dateArr[1];
      this.toDetail(this.selectedCode);
    },
    // 加载视频列表
    loadVideoList: function loadVideoList(id) {
      var _this = this;

      var params = {
        pageNo: 1,
        pageSize: 1000
      };
      this.videoList = [];
      params.siteId = id;
      getAction('site/photo/querySiteLiveFirst', params).then(function (res) {
        if (res.success && res.result) {
          _this.videoList = res.result;
        }
      });
    },
    toDetail: function toDetail(code) {
      var _this2 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.selectedCode = code;
      this.photoList = [];
      this.showPhoto = true;
      this.params.videoCode = code ? code : this.selectedCode;
      this.params.siteId = this.siteId;
      this.params.pageNo = this.paginationIndex;
      this.params.pageSize = 27;
      this.params.column = 'time';
      this.params.order = this.order;
      this.total = 0;
      getAction('site/photo', this.params).then(function (res) {
        if (res.success && res.result) {
          res.result.records.forEach(function (item, index) {
            // let obj = {}
            item.src = _this2.getImageView(item.id); // this.photoList.push(obj)
          });
          _this2.total = res.result.total;
          _this2.photoList = res.result.records; // 预览组件刷新

          _this2.$previewRefresh();

          console.log('this.photoList', _this2.photoList); // this.photoList = res.result.records
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url + photo;
    }
  }
};